export const getFormattedAttachment = (attachment) => {
  if (attachment && Array.isArray(attachment)) {
    return attachment.map((item) => {
      return {
        ...(item.response ?? {}),
        ...item,
        fileSize: item.size.toString(),
      };
    });
  } else {
    return [];
  }
};
